const COLORS = { "Evacuation Center": "#15803d", "Hazard Zone": "#b91c1c", "Barangay Facility": "#1d4ed8", "Project Site": "#b45309", "Purok Center": "#7c2d12", Other: "#475569" };

export default function MiniMap({ points, testid = "gis-map" }) {
  const valid = points.filter((p) => typeof p.latitude === "number" && typeof p.longitude === "number");
  const lats = valid.map((p) => p.latitude);
  const lngs = valid.map((p) => p.longitude);
  const pad = 0.002;
  const [minLat, maxLat] = [Math.min(...lats) - pad, Math.max(...lats) + pad];
  const [minLng, maxLng] = [Math.min(...lngs) - pad, Math.max(...lngs) + pad];
  const pos = (p) => ({ left: `${((p.longitude - minLng) / (maxLng - minLng || 1)) * 100}%`, top: `${(1 - (p.latitude - minLat) / (maxLat - minLat || 1)) * 100}%` });
  return (
    <div className="rounded-md border bg-white p-4" data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <p className="overline-label">Map abstraction (no map provider key configured)</p>
        <div className="flex flex-wrap gap-3 text-[11px]">
          {Object.entries(COLORS).map(([k, c]) => <span key={k} className="flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: c }} />{k}</span>)}
        </div>
      </div>
      <div className="relative h-64 rounded grid-paper bg-slate-50 overflow-hidden">
        {valid.length === 0 && <p className="absolute inset-0 flex items-center justify-center text-sm text-slate-500">No mapped features</p>}
        {valid.map((p, i) => (
          <div key={i} className="absolute -translate-x-1/2 -translate-y-1/2 group" style={pos(p)} data-testid={`map-point-${i}`}>
            <span className="block h-3.5 w-3.5 rounded-full ring-2 ring-white shadow" style={{ background: COLORS[p.layer] || COLORS.Other }} />
            <span className="absolute left-4 top-0 whitespace-nowrap rounded bg-slate-900 px-2 py-0.5 text-[11px] text-white opacity-0 group-hover:opacity-100 transition-opacity">{p.feature_name}</span>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-2">Relative positions from recorded latitude/longitude. Configure Google Maps in System Settings for basemap tiles.</p>
    </div>
  );
}
